/* eslint @typescript-eslint/no-unnecessary-condition: 0 */
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';

import { ObserveSizeDirective } from '@frontend/vanilla/core';

import { CarouselService } from '../../../shared/directives/ng-carousel/carousel.service';
import { PreCreatedBetBuilder } from '../../../shared/directives/precreatedBetBuilder/precreated-betbuilder';
import { SharedModule } from '../../../shared/shared.module';
import { PreCreatedAddToBetslipComponent } from '../../PreCreatedBetBuilder/preCreatedBetBuilderAddToBetslip/pre-created-add-to-betslip.component';
import { FeaturedBybWidgetService } from '../../bybWidget/services/featured-byb-widget.service';
import { PagerService } from '../../bybWidget/services/pagination.service';

@Component({
    standalone: true,
    selector: 'precreated-betbuilder',
    templateUrl: './precreated-betbuilder.component.html',
    styleUrls: ['./precreated-betbuilder.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [SharedModule, CommonModule, ObserveSizeDirective, PreCreatedAddToBetslipComponent],
    providers: [PagerService, FeaturedBybWidgetService, CarouselService],
})
export class PreCreatedBetBuilderComponent extends PreCreatedBetBuilder {}
